<ng-template #template>
    <input type="hidden" #btnCallMe />
    <div class="modal-body text-center" data-backdrop="static"  data-keyboard="false">
        <p>Please confirm your request to have a licensed insurance agent contact you at the Preferred Phone number entered. Confirmation of the callback request will save your information and end the online quote process.</p>
        <button type="button" class="btn btn-RTQ m-2"  (click)="confirm($event)" >Yes, Call me</button>
        <button type="button" class="btn btn-RTQ " (click)="decline()" >Cancel</button>
    </div>
</ng-template>
